import './App.css';
import './App.scss';

function App() {
  return (
    <div className="main">
      <h1>Portfolio</h1>
      <div className="sections">

        <div className="section">
            <h2>Strony</h2>
            <div className="websites">
              <div className="website">
                <a href="https://fotdom.pl" target="_blank" rel="noopener noreferrer">
                  <img src="/images/site1.jpg" alt="Strona 1" />
                </a>
                <div className="link"><a href="https://fotdom.pl" target="_blank" rel="noopener noreferrer">Zobacz stronę</a></div>
                <div className="tech">WordPress</div>
              </div>

              <div className="website">
                <a href="https://hotel-booking-site-react.netlify.app/" target="_blank" rel="noopener noreferrer">
                  <img src="/images/site2.jpg" alt="Strona 2" />
                </a>
                <div className="link"><a href="https://hotel-booking-site-react.netlify.app/" target="_blank" rel="noopener noreferrer">Zobacz stronę</a></div>
                <div className="tech">React</div>
              </div>

              <div className="website">
                <a href="https://oddam-w-dobre-rynce.netlify.app/" target="_blank" rel="noopener noreferrer">
                  <img src="/images/site3.jpg" alt="Strona 3" />
                </a>
                <div className="link"><a href="https://oddam-w-dobre-rynce.netlify.app/" target="_blank" rel="noopener noreferrer">Zobacz stronę</a></div>
                <div className="tech">React</div>
              </div>

              <div className="website">
                <a href="https://mdkjelonek.pl/" target="_blank" rel="noopener noreferrer">
                  <img src="/images/site4.jpg" alt="Strona 4" />
                </a>
                <div className="link"><a href="https://mdkjelonek.pl/" target="_blank" rel="noopener noreferrer">Zobacz stronę</a></div>
                <div className="tech">WordPress</div>
              </div>
            </div>
          </div>

          <div className="section">
            <h2>Zdjęcia z drona</h2>
            <div className="gallery six-columns">
            {[1,2,3,4,5,6,7,8,9,10,11,12].map((num) => (
                <a key={num} href={`/images/drone${num}.jpg`} target="_blank" rel="noopener noreferrer">
                <img src={`/images/drone${num}.jpg`} alt={`drone${num}`} />
                </a>
              ))}
            </div>
          </div>

          <div className="section">
            <h2>Stable Diffusion / Flux </h2>
            <p>(on 8 GB VRAM GPU)</p>
            <br></br><p>2025</p>
            <div className="gallery six-columns">
              {[1,2,3,4,5,6,7,8,9,10,11,12].map((num) => (
              <a key={num} href={`/images/ComfyUI${num}.png`} target="_blank" rel="noopener noreferrer">
                <img src={`/images/ComfyUI${num}.png`} alt={`ComfyUI${num}`} />
              </a>
              ))}
            </div>
            <br></br><p>2023/2024</p>
            <div className="gallery six-columns">
              {[1,2,3,4,5,6,7,8,9,10,11,12].map((num) => (
              <a key={num} href={`/images/photo${num}.png`} target="_blank" rel="noopener noreferrer">
                <img src={`/images/photo${num}.png`} alt={`photo${num}`} />
              </a>
              ))}
            </div>
          </div>

      </div>
    </div>
  );
}

export default App;
